import React, { useState } from "react";
import { Card, CardHeader, CardContent, IconButton, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

interface CollapsibleCardProps {
    title: React.ReactNode;
    subheader?: React.ReactNode;
    avatar?: React.ReactNode;
    action?: React.ReactNode;
    children: React.ReactNode;
    defaultExpanded?: boolean;
}

const CollapsibleCard: React.FC<CollapsibleCardProps> = ({
    title,
    subheader,
    avatar,
    action,
    children,
    defaultExpanded = true,
}) => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    return (
        <Card
            sx={{
                borderRadius: 3,
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                transition: 'box-shadow 0.2s',
                width: "100%",
                alignSelf: 'center',
            }}
        >
            <CardHeader
                avatar={avatar}
                title={title}
                subheader={subheader}
                action={
                    <>
                        {action}
                        <IconButton onClick={() => setExpanded((prev) => !prev)}>
                            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </>
                }
                sx={{
                    minHeight: 72,
                    alignItems: 'center',
                    '& .MuiCardHeader-content': {
                        display: 'flex',
                        alignItems: 'center',
                    },
                }}
            />
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent sx={{ pt: 0 }}>{children}</CardContent>
            </Collapse>
        </Card>
    );
};

export default CollapsibleCard;
